'use client'

import { DropdownMenuItem, type NavbarItemVariant, NavbarLink } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'
import { useLoggedIn } from '@/shared/providers/public-id'

export function AboutPageLink({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const { i18n } = useI18n()
    const runtimeEnv = getPublicEnv()
    const loggedIn = useLoggedIn()

    const href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}/about/taonga-farming-game`

    if (!runtimeEnv.NEXT_PUBLIC_NAVBAR_ABOUT_PAGE_LINK_ENABLE || loggedIn) {
        return null
    }

    if (variant === 'default') {
        return (
            <NavbarLink href={href} className={css({ display: { base: 'none', xl: 'flex' } })}>
                {i18n.PORTAL_ABOUT}
            </NavbarLink>
        )
    }

    return (
        <DropdownMenuItem href={href} target="_blank" rel="noopener noreferrer">
            <i className={cx('fa-light fa-bird', css({ color: 'success' }))} />
            &nbsp;{i18n.PORTAL_ABOUT}
        </DropdownMenuItem>
    )
}
